import { iDataCreate } from '../../../model/app/Application';
import React from 'react';
import { useTranslation } from 'react-i18next';
export const FunctionCreate = ({
  showForm,
  setShowForm,
  createData,
  changeHandler,
}: iDataCreate) => {
  const { t } = useTranslation();
  return (
    <div className="col-12">
      <div className="card">
        <div
          className={`card-header pb-0 d-flex justify-content-between align-items-center flex-column flex-md-row ${
            !showForm && 'pb-4'
          }`}
        >
          <div>
            <div className="d-flex justify-content-between">
              <h4 className="card-title mg-b-0">
                {t('Functions.create_new_function')}
              </h4>
            </div>
            <p className="tx-12 tx-gray-500 mb-2">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            </p>
          </div>
          {!showForm && (
            <button
              className="btn btn-primary"
              onClick={() => setShowForm(!showForm)}
            >
              {t('Functions.add_function')}
            </button>
          )}
        </div>
        {showForm && (
          <div className="card-body">
            <div className="form-group mb-0">
              <label htmlFor="title">{t('Functions.title')}</label>
              <input
                type="text"
                className="form-control"
                name="title"
                onChange={changeHandler}
                placeholder={t('Functions.enter_title')}
              />
            </div>
            <div className="d-flex justify-content-end w-100">
              <button
                onClick={createData}
                className="btn btn-primary mt-3 mb-0"
              >
                {t('Functions.create_function')}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
